import React, { useState, useEffect } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import generator from './generator';

import './index.css';

const Component = (props) => {
    const { data, type } = props;

    const [apa, setAPA] = useState('');
    const [bib, setBib] = useState('');

    useEffect(() => {
        const { APA, BIB } = generator(data, type);

        setAPA(APA);
        setBib(BIB);
    }, []);

    return (
        <span>
            <CopyToClipboard text={apa}>
                <span>
                    <span className="ref-bibtex">
                        <i className="far fa-copy" /> APA
                    </span>
                </span>
            </CopyToClipboard>
            &nbsp;&nbsp;
            <CopyToClipboard text={bib}>
                <span className="ref-bibtex">
                    <i className="far fa-copy" /> .bib
                </span>
            </CopyToClipboard>
        </span>
    );
};

export default Component;
